module.exports = __webpack_public_path__ + "static/media/user-solid.c2e16be5.png";